<template>
    <div class="z-preloader">
        <span class="z-preloader__inner"></span>
    </div>
</template>

<script>
export default {
    name: 'z-preloader'
}
</script>

<style lang="scss">
.z-preloader {
    display: flex;
    justify-content: center;
    margin: auto;
    padding: 32px 0;
    text-align: center;

    &__inner {
        display: block;
        height: 100px;
        width: 100px;
        border-radius: 100%;
        border-top: 5px solid $token-colors-primary;
        border-right: 4px double #E42213;
        border-left: 4px double #E42213;
        border-bottom: 5px solid $token-colors-primary;
        animation: ZPreloader 2s linear infinite;
    }
}

@keyframes ZPreloader {

    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
